import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCitation } from '../Citation/useCitation/useCitation';
import { PropertyDefinitionsProvider } from '../PropertyDefinitionsProvider/PropertyDefinitionsProvider';
import { usePropertyDefinition } from '../PropertyDefinitionsProvider/usePropertyDefinition';
import { jsx as _jsx } from "react/jsx-runtime";
const CitaitonPanelHeadingInternal = ({
  citation
}) => {
  const {
    propertyDefinition
  } = usePropertyDefinition(citation.propertyName);
  if (!propertyDefinition) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "smartPropertyCitationPanel.title"
    });
  }

  // TODO: Add in the record label as well
  return propertyDefinition.property.label;
};
export const CitationPanelHeading = () => {
  const {
    citation
  } = useCitation();
  if (!citation) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "smartPropertyCitationPanel.title"
    });
  }
  return /*#__PURE__*/_jsx(PropertyDefinitionsProvider, {
    objectTypeId: citation.objectTypeId,
    children: /*#__PURE__*/_jsx(CitaitonPanelHeadingInternal, {
      citation: citation
    })
  });
};